"use client";
import React, { useState, useEffect } from "react";
import Product from "./models/Product";
import ProductPrice from "./components/Price";
import ProductPageClient from "./products/[slug]/ProductPageClient";
import ScrollToTopButton from "./components/ScrollToTopButton";
import WhatsAppButton from "./components/buttons/WhatsAppButton";

export const ProductList: React.FC<{ products: Product[] }> = ({ products }) => {
    const [multiplier, setMultiplier] = useState(1);
    const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
    const [clientSideProducts, setClientSideProducts] = useState<Product[]>([]);

    useEffect(() => {
        const randomized = [...Array(multiplier)]
            .fill(products)
            .flat()
            .map((p) => {
                const index = Math.floor(Math.random() * 6);
                return {
                    ...p,
                    randomImageIndex: p.images[index] ? index : 0,
                };
            })
            .sort(() => Math.random() - 0.5);

        setClientSideProducts(randomized);
    }, [products, multiplier]);

    const handleShowMore = () => {
        setMultiplier((prev) => prev * 2);
    };

    const handleProductClick = (product: Product) => {
        products.unshift(product);
        setSelectedProduct(product);
        document.title = product.name;
        window.history.pushState(null, '', `/products/${encodeURIComponent(product.uniqueName)}`);
    };

    const handleCloseModal = () => {
        setSelectedProduct(null);
    };

    return (
        <>
            <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
                {clientSideProducts.map((product, index) => (
                    <div
                        key={index + "-" + product.uniqueName + "-" + product.randomImageIndex}
                        className="block no-underline text-inherit mb-4 break-inside-avoid"
                        onClick={() => handleProductClick(product)}
                    >
                        <div className="cursor-pointer rounded-lg overflow-hidden shadow-md bg-white relative">

                            <div
                                className="transition-transform duration-300 ease-in-out hover:scale-110 bg-contain bg-no-repeat bg-center w-full h-[450px]"
                                style={{
                                    backgroundImage: `url(${product.images[product.randomImageIndex]})`,
                                }}
                            ></div>

                            <div className="p-4">
                                <h2 className="text-lg font-bold text-gray-800">{product.name}</h2>
                                <ProductPrice product={product} showPromoPrice={true} />
                            </div>

                            <div className="p-4">
                            <WhatsAppButton product={product} />   
                            </div>
                            

                        </div>

                             

                    </div>
                ))}
            </div>

            <div className="flex justify-center mt-6">
                <button
                    onClick={handleShowMore}
                    className="bg-black text-white px-6 py-3 rounded-full font-semibold hover:bg-gray-800 transition w-[350px]"
                >
                    Voir plus
                </button>
            </div>

            {selectedProduct && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center">
                    <div className="bg-[#000] w-full h-full p-4 overflow-auto relative">
                        <button
                            style={{
                                width: '32px',
                                height: '32px',
                                background: '#000',
                                color: '#fff',
                                fontSize: '30px',
                                borderRadius: '50%',
                                lineHeight: '32px'
                            }}
                            onClick={handleCloseModal}
                            className="absolute top-4 right-4 text-black text-3xl font-bold z-10"
                        >
                            &times;
                        </button>
                        <ProductPageClient product={selectedProduct} products={products} />
                    </div>
                </div>
            )}

            <ScrollToTopButton />
        </>
    );
};
